import { PUT_OUR_WORK_START } from '../../types';

export const put_our_work = (payload) => ({
  type: PUT_OUR_WORK_START,
  payload,
});
